import RecordPreviewSection from '#/common/components/RecordPreview/RecordPreviewSection';

export default RecordPreviewSection;
